import React from 'react';
import t from '@jetshop/intl';
import searchQuery from '../Layout/Header/Search/SearchQuery.gql';
import { Query } from 'react-apollo';
import qs from 'qs';
import PaginationContainer from '@jetshop/core/components/Pagination/PaginationContainer';
import get from 'lodash.get';
import FilterContainer from '@jetshop/core/components/Filters/FilterContainer';
import { SearchResults } from './';
import EmptySearchResults from './EmptySearchResults';
import styled from 'react-emotion';

import SearchPageBehaviour from '@jetshop/ui/Search/SearchPage/SearchPageBehaviour';

const StyledSearchResults = styled('div')`
  .your-model {
    opacity: 0;
  }
`;

const renderResults = searchProps =>
  searchProps.total > 0 || searchProps.loading ? (
    <StyledSearchResults>
      <SearchResults {...searchProps} />
    </StyledSearchResults>
  ) : (
    <EmptySearchResults term={searchProps.term} result={searchProps.result} />
  );

const SearchPage = routeProps => {
  return (
    <SearchPageBehaviour searchQuery={searchQuery} {...routeProps}>
      {({ error, ...searchProps }) =>
        error ? (
          <div error={error}>{t('An error occured. Please try again!')}</div>
        ) : (
          renderResults(searchProps)
        )
      }
    </SearchPageBehaviour>
  );
};

export default SearchPage;
